/**
 * Tailwind color map for the internal-status badges.
 * Keys match ALLOWED_INTERNAL_STATUS_COLORS on the backend.
 */
export const INTERNAL_STATUS_COLOR_CLASSES = {
  slate: 'bg-slate-100 text-slate-700 border-slate-200',
  zinc: 'bg-zinc-100 text-zinc-700 border-zinc-200',
  red: 'bg-red-100 text-red-700 border-red-200',
  rose: 'bg-rose-100 text-rose-700 border-rose-200',
  orange: 'bg-orange-100 text-orange-700 border-orange-200',
  amber: 'bg-amber-100 text-amber-700 border-amber-200',
  yellow: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  lime: 'bg-lime-100 text-lime-700 border-lime-200',
  green: 'bg-green-100 text-green-700 border-green-200',
  emerald: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  teal: 'bg-teal-100 text-teal-700 border-teal-200',
  cyan: 'bg-cyan-100 text-cyan-700 border-cyan-200',
  sky: 'bg-sky-100 text-sky-700 border-sky-200',
  blue: 'bg-blue-100 text-blue-700 border-blue-200',
  indigo: 'bg-indigo-100 text-indigo-700 border-indigo-200',
  violet: 'bg-violet-100 text-violet-700 border-violet-200',
  purple: 'bg-purple-100 text-purple-700 border-purple-200',
  pink: 'bg-pink-100 text-pink-700 border-pink-200',
};

export function internalStatusBadgeClasses(color) {
  return INTERNAL_STATUS_COLOR_CLASSES[color] || INTERNAL_STATUS_COLOR_CLASSES.slate;
}

/**
 * Due-date presets. Returns an ISO string at the target time (UTC).
 */
export const DUE_DATE_PRESETS = [
  {
    key: 'unknown',
    label: 'Unknown',
    compute: () => null,
  },
  {
    key: '4_hours',
    label: 'In next 4 hours',
    compute: () => {
      const d = new Date();
      d.setHours(d.getHours() + 4);
      return d.toISOString();
    },
  },
  {
    key: 'today',
    label: 'Today (end of day)',
    compute: () => {
      const d = new Date();
      d.setHours(23, 59, 0, 0);
      return d.toISOString();
    },
  },
  {
    key: '2_days',
    label: 'In next 2 days',
    compute: () => {
      const d = new Date();
      d.setDate(d.getDate() + 2);
      d.setHours(17, 0, 0, 0);
      return d.toISOString();
    },
  },
  {
    key: '4_days',
    label: 'In next 4 days',
    compute: () => {
      const d = new Date();
      d.setDate(d.getDate() + 4);
      d.setHours(17, 0, 0, 0);
      return d.toISOString();
    },
  },
  {
    key: '1_week',
    label: 'In next 1 week',
    compute: () => {
      const d = new Date();
      d.setDate(d.getDate() + 7);
      d.setHours(17, 0, 0, 0);
      return d.toISOString();
    },
  },
];

export function formatDueDate(iso) {
  if (!iso) return 'Not set';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'Not set';
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function dueDateRelative(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const diffMs = d.getTime() - Date.now();
  const absMin = Math.round(Math.abs(diffMs) / 60000);
  const absHr = Math.round(absMin / 60);
  const absDay = Math.round(absHr / 24);

  const prefix = diffMs >= 0 ? 'in ' : '';
  const suffix = diffMs >= 0 ? '' : ' ago';

  let core;
  if (absHr < 1) core = `${absMin}m`;
  else if (absHr < 24) core = `${absHr}h`;
  else core = `${absDay}d`;
  return `${prefix}${core}${suffix}`;
}
